import axios from "axios"
import jwt_decode from 'jwt-decode'
import { setStorage, getStorage } from '../utils/storage'
import store from "../store"
import { message } from "antd"
import { login } from '../store/modules/user';

const instance = axios.create({
  baseURL: '/api',
  // timeout: 5000
})

instance.interceptors.request.use((config) => {
  if (config.url !== '/api/auth') {
    //从Storage取出token
    const accessToken = getStorage("accessToken")
    if (accessToken)
      config.headers = { ...config.headers, Authorization: `Bearer ${accessToken}` }
    const refreshToken = getStorage('refreshToken')
    if (refreshToken)
      config.headers = { ...config.headers, 'X-Authorization': `Bearer ${refreshToken}` }
  }
  return config
}, err => {
  message.error(err.message)
})

instance.interceptors.response.use((res) => {
  if (res.headers['access-token'] && res.headers['access-token'] !== 'invalid_token' && res.headers["x-access-token"]) {
    //  将token写入Storage
    setStorage('accessToken', res.headers['access-token'])
    setStorage('refreshToken', res.headers['x-access-token'])
    store.dispatch(login(jwt_decode(res.headers['access-token'])))
  }
  return res
}, err => {
  message.error(err.message)
})

const ajax = (config) => instance(config)
  .then(res => {
    const { statusCode, data, succeeded, errors } = res.data
    if (succeeded) return data
    else if (statusCode === 403) {
      message.error('抱歉，请登录！')
    }
    else if (statusCode === 401) {
      message.error('抱歉，权限不够！')
    }
    else {
      message.error(errors)
      // return null
    }
  })
  .catch(err => {
    console.log(err)
    message.error(err.message)
    // return null
  })

export const getAsync = (url, params) => ajax({ url, params })
export const postAsync = (url, data, onUploadProgress) => ajax({ url, data, method: 'post', onUploadProgress })
export const putAsync = (url, data) => ajax({ url, data, method: 'put' })
export const deleteAsync = (url, params) => ajax({ url, params, method: 'delete' })